<template>
    <div class="home-steps-screen-carousel">
        <img src="imgs/empty-phone.webp" class="home-steps-screen-carousel-base-image">
        <div class="home-steps-screen-carousel-container">
            <div :style="{'margin-left': '-' + offset + '%'}" class="home-steps-screen-carousel-container-inner">
                <img v-for="i in 5" :key="i" :src="`/imgs/how-it-works/${i}-${locale}.webp`">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        index: Number,
    },
    data() {
        return {
            offset: 0,
            targetOffset: 0,
            animationSteps: 0,
        };
    },
    computed: {
        locale() {
            return window.appLocale;
        },
    },
    watch: {
        index(value) {
            this.targetOffset = 100 * (value - 1);
            this.animationSteps = 40;
        },
    },
    mounted() {
        setInterval(() => {
            if (this.animationSteps > 0) {
                this.offset += (this.targetOffset - this.offset) / this.animationSteps;
                this.animationSteps--;
            }
        }, 10);
    },
};
</script>

<style lang="scss" scoped>
.home-steps-screen-carousel {
    position: relative;
    width: 245px;
    height: 461px;
    .home-steps-screen-carousel-base-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 3;
    }
    .home-steps-screen-carousel-container {
        position: absolute;
        top: 14px;
        left: 15px;
        width: calc(100% - 28px);
        z-index: 2;
        overflow: hidden;
        height: 468px;
        .home-steps-screen-carousel-container-inner {
            display: flex;
            width: 500%;
            height: 100%;
            img {
                width: 20%;
                height: 100%;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HomeStepsScreenCarousel.vue